import type { ContractFilterInput, DashboardFilterInput } from '@/graphql/generated';


export function contractFilterInputFromDashboard(
  f: DashboardFilterInput | undefined,
): Partial<
  Pick<
    ContractFilterInput,
    'propertyId' | 'countryId' | 'stateId' | 'cityId' | 'year' | 'month' | 'dateFrom' | 'dateTo'
  >
> {
  if (!f) return {};
  const out: Partial<
    Pick<
      ContractFilterInput,
      'propertyId' | 'countryId' | 'stateId' | 'cityId' | 'year' | 'month' | 'dateFrom' | 'dateTo'
    >
  > = {};
  if (f.propertyId) out.propertyId = f.propertyId;
  if (f.countryId) out.countryId = f.countryId;
  if (f.stateId) out.stateId = f.stateId;
  if (f.cityId) out.cityId = f.cityId;
  if (f.year != null) out.year = f.year;
  if (f.month != null && f.month >= 1 && f.month <= 12) out.month = f.month;
  if (f.dateFrom != null) out.dateFrom = f.dateFrom;
  if (f.dateTo != null) out.dateTo = f.dateTo;
  return out;
}
